import { toast } from 'react-hot-toast';

const dismiss = (id) => toast.dismiss(id);

export default dismiss;
